module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/autorizacao-tipo/autorizacao-tipo.component.css
// module id = ./src/app/autorizacao-tipo/autorizacao-tipo.component.css
// module chunks = main